module.exports = __webpack_public_path__ + "static/media/conheca-o-canal-da-Alura.28d3761d.mp4";